<template>
  <div class="styleCard">
    <h2>Users Management</h2>
    <div id="first-stage">
      <h4>Please Choose Operation:</h4>
      <div class="form-group">
        <div class="radio ">
          <label>
            <input
              checked=""
              id="optionsRadios1"
              name="optionsRadios"
              type="radio"
              v-on:change="optionChoose('ADD')"
              value="option1"
            />
            Add New User
          </label>
        </div>
        <div class="radio">
          <label>
            <input
              id="optionsRadios2"
              name="optionsRadios"
              type="radio"
              v-on:change="optionChoose('EDIT')"
              value="option2"
            />
            Edit Existing User
          </label>
        </div>
        <div class="radio">
          <label>
            <input
              id="optionsRadios5"
              name="optionsRadios"
              type="radio"
              v-on:change="optionChoose('UPDATE_IMAGE')"
              value="option3"
            />
            Update Profile Image
          </label>
        </div>
        <div></div>
        <!--        <div class="radio">-->
        <!--          <label>-->
        <!--            <input-->
        <!--              id="optionsRadios4"-->
        <!--              name="optionsRadios"-->
        <!--              type="radio"-->
        <!--              v-on:change="optionChoose('DELETE')"-->
        <!--              value="option3"-->
        <!--            />-->
        <!--            Delete User-->
        <!--          </label>-->
        <!--        </div>-->
      </div>
    </div>
    <br />

    <div v-if="selectProfileImage">
      <h4>{{ type }}</h4>
      <div class="form-group filter-multiselect">
        <label for="delNamesOptions">Choose User</label>
        <multiselect
          :options="usersOptions"
          @input="selectNameToEdit"
          id="delNamesOptions"
          label="email"
          track-by="id"
          v-model="selectedName"
        ></multiselect>
      </div>
      <div v-if="id !== ''">
        <label>Profile image</label>
        <img :src="previewImage" class="uploading-image" />
        <input
          type="file"
          accept="image/jpeg"
          @change="uploadImage"
          class="img-selector"
        />
      </div>

      <br />

      <button @click="showUserMgmt()" class="bttn bttn-green">Finish</button>
    </div>
    <div id="DeleteUser" v-if="selectDelete">
      <h4>{{ type }} User</h4>
      <div class="form-group filter-multiselect">
        <label for="delNamesOptions">Choose User To Delete</label>
        <select
          @change="selectNameToEdit(selectedName)"
          class="select-standard"
          v-model="selectedName"
        >
          <option :value="null">Select User</option>
          <option
            v-for="person in usersOptions"
            :key="person.id"
            :value="person"
            >{{ person.full_name }}
          </option>
        </select>
      </div>
      <div class="delNameBox">
        <label>User Details:</label>
        <h5>
          First Name: {{ this.selectedName.first_name }} &nbsp; Last Name:
          {{ this.selectedName.last_name }}
        </h5>
      </div>
      <span class="caution"> Caution! this operation is irreversible!</span>
      <div class="form-group">
        <div class="btnBoxLeft">
          <button @click="showUserMgmt()" class="bttn  bttn-red" type="button">
            Cancel
          </button>
          <button @click="submitDelete()" class="bttn  bttn-blue" type="button">
            Delete
          </button>
        </div>
      </div>
      <br />
      <div v-if="errors.length">
        <b>Please correct the following error(s):</b>

        <ul>
          <li v-for="error in errors" v-bind:key="error">{{ error }}</li>
        </ul>
      </div>
      <br />
    </div>
    <div id="userAddEdit" v-if="selectAdd || selectEdit">
      <h4>{{ type }} User</h4>
      <div class="form-group filter-multiselect" v-if="selectEdit">
        <label>Select User</label>
        <select
          @change="selectNameToEdit(selectedName)"
          class="select-standard"
          v-model="selectedName"
        >
          <option :value="null">Select User</option>
          <option
            v-for="person in usersOptions"
            :key="person.id"
            :value="person"
            >{{ person.full_name }}
          </option>
        </select>
      </div>

      <div id="first" v-if="!detailsStageCompleted">
        <div class="form-group filter-multiselect">
          <label>Select Role</label>
          <select
            class="select-standard"
            v-model="role"
            v-if="dictionaries.general"
          >
            <option :value="null">Select Role</option>
            <option
              v-for="role in dictionaries.general.roles"
              :key="role.id"
              :value="role.id"
              >{{ role.role }}
            </option>
          </select>
        </div>
        <div class="form-group filter-multiselect">
          <label>Select Team</label>
          <select
            class="select-standard"
            v-model="team"
            v-if="dictionaries.general"
          >
            <option :value="null">Select Role</option>
            <option
              v-for="team in dictionaries.general.teams"
              :key="team.id"
              :value="team.id"
              >{{ team.title }}
            </option>
          </select>
        </div>

        <div class="form-group">
          <label for="first_name">First Name</label>
          <input
            class="form-control"
            id="first_name"
            name="first_name"
            placeholder="Enter First Name "
            required
            type="text"
            v-model="firstName"
          />
        </div>
        <div class="form-group">
          <label for="first_name">Last Name</label>
          <input
            class="form-control"
            id="last_name"
            name="last_name"
            placeholder="Enter Last Name"
            type="text"
            v-model="lastName"
          />
        </div>
        <div class="form-group">
          <label for="voip_ext">VoIP Ext Number</label>
          <input
            class="form-control"
            id="voip_ext"
            name="first_name"
            placeholder="Enter VoIP Ext Number"
            required
            type="text"
            v-model="voip_user"
          />
        </div>
        <div class="form-group" v-if="backup_voip_enable">
          <label for="voip_ext_bak">Backup VoIP Ext Number</label>
          <input
            class="form-control"
            id="voip_ext_bak"
            name="first_name"
            placeholder="Enter Backup VoIP Ext Number"
            required
            type="text"
            v-model="backup_voip_user"
          />
        </div>
        <div class="root">
          <div class="top-check-div">
            <label class="multi-check-label" for="active">
              <input
                type="checkbox"
                class="multi-check"
                v-model="active"
                id="active"
              />
              Active
            </label>
            <label class="multi-check-label" for="stats_active">
              <input
                type="checkbox"
                class="multi-check"
                v-model="stats_active"
                id="stats_active"
              />
              Active For Statistic</label
            >
            <label class="multi-check-label" for="reports_active">
              <input
                type="checkbox"
                class="multi-check"
                v-model="reports_active"
                id="reports_active"
              />
              Active For Statics Reports</label
            >
            <label
              class="multi-check-label strong-label"
              for="backup_voip_active"
            >
              <input
                type="checkbox"
                class="multi-check"
                v-model="backup_voip_enable"
                id="backup_voip_active"
              />
              Enable Backup VoIP Ext</label
            >
          </div>
        </div>

        <br />

        <div class="form-group text-right">
          <button @click="showUserMgmt()" class="bttn bttn-red" type="button">
            Cancel
          </button>
          <button @click="next()" class="bttn bttn-blue" type="button">
            Next
          </button>
        </div>
      </div>
      <div id="second" v-if="detailsStageCompleted">
        <p>Fill User Login Details</p>
        <div class="form-group">
          <label for="email">Email Address</label>
          <input
            class="form-control"
            id="email"
            name="email"
            placeholder="Enter email"
            type="email"
            v-model="email"
          />
        </div>
        <div class="top-check-div" v-if="selectEdit">
          <label class="multi-check-label" for="pass_change">
            <input
              type="checkbox"
              class="multi-check"
              v-model="wantChangePassword"
              id="pass_change"
            />
            Change Password ?</label
          >
        </div>
        <div v-if="(wantChangePassword && selectEdit) || selectAdd">
          <div class="form-group">
            <label for="password">Password / Username_Special</label>
            <input
              class="form-control"
              id="password"
              name="password"
              placeholder="Enter Password"
              type="password"
              v-model="password"
            />
          </div>
          <div class="form-group">
            <label for="repassword">Retype Password / Username_Special</label>
            <input
              class="form-control"
              id="repassword"
              name="repassword"
              placeholder="Enter Password Again"
              type="password"
              v-model="rePassword"
            />
          </div>
        </div>
        <br />
        <div class="form-group">
          <div class="btnBoxLeft">
            <button @click="showUserMgmt()" class="bttn bttn-red">
              Cancel
            </button>
            <button
              @click="submitAdd('add')"
              class="bttn bttn-blue"
              v-if="selectAdd"
            >
              Add User
            </button>
            <button
              @click="submitAdd('edit')"
              class="bttn bttn-blue"
              v-if="selectEdit"
            >
              Update User
            </button>
          </div>
          <button @click="back()" class="bttn bttn-blue ">Back</button>
        </div>
        <br />
        <div v-if="errors.length">
          <b>Please correct the following error(s):</b>
          <ul>
            <li v-for="error in errors" v-bind:key="error">{{ error }}</li>
          </ul>
        </div>
      </div>
    </div>
    <br />
    <br />
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import Multiselect from "vue-multiselect";
import apiClientCreator from "../../../helpers/api/request";

export default {
  name: "AddEditUsersContainer",
  props: {
    options: {
      type: Array,
      default: () => []
    }
  },
  components: {
    Multiselect
  },

  computed: {
    ...mapState("user", ["auth"]),
    ...mapState("clients", ["dictionaries"]),
    ...mapGetters("clients", ["AddEditUsersOpened", "AddEditBrokersOpened"])
  },

  data() {
    return {
      selectedItems: [],
      type: "Add",
      selectAdd: true,
      selectDelete: false,
      selectEdit: false,
      errors: [],
      selectedName: "",
      id: "",
      role: "",
      team: "",
      firstName: "",
      lastName: "",
      country: "",
      socialNumber: "",
      email: "",
      username_special: "",
      password: null,
      rePassword: null,
      imageFile: "",
      detailsStageCompleted: false,
      usersOptions: [],
      previewImage: null,
      selectedImage: null,
      selectProfileImage: false,
      active: false,
      stats_active: false,
      reports_active: false,
      backup_voip_enable: false,
      voip_user: null,
      backup_voip_user: null,
      wantChangePassword: false
    };
  },
  created: function() {
    this.fetchUsers();
  },

  methods: {
    checkActiveSelected() {
      this.selectedItems = [];
      let person;
      this.active = !this.active;
      if (this.active) {
        for (person in this.options) {
          this.selectedItems.push(this.options[person]);
        }
      }
    },
    checkStatisticSelected() {
      this.selectedItems = [];
      let person;
      this.stats_active = !this.stats_active;
      if (this.stats_active) {
        for (person in this.options) {
          this.selectedItems.push(this.options[person]);
        }
      }
    },
    uploadImage(e) {
      const image = e.target.files[0];
      this.selectedImage = image;
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = er => {
        this.previewImage = er.target.result;
      };

      const formData = new FormData();
      formData.append("image", this.selectedImage);
      const apiClient = apiClientCreator(`admin/user/profile/img/${this.id}`);
      apiClient.post("", formData).then(res => {});
    },

    fetchUsers: async function() {
      let apiClient = apiClientCreator("admin/users");
      let response = await apiClient.get("");
      this.usersOptions = response.data.users;
      // this.stats_active = response.data.users.stats_active;
      // this.active = response.data.users.active;
    },
    addNewUser: function(newUser) {
      const apiClient = apiClientCreator("admin/user");
      apiClient.post("", newUser).then(
        res => {
          if (res.status === 201) {
            alert(`The User ${newUser.email} Added Successfully`);
            if (confirm("Are you want to Add another User ?")) {
              this.resetForm();
              this.detailsStageCompleted = false;
            } else {
              this.showUserMgmt();
            }
            this.fetchUsers();
          }
        },
        () => {
          alert(
            `Cannot Add User: The User/password is already exist, please try again`
            // `Cannot Add User: The User ${newUser.email} is already registered, please try another Username`
          );
        }
      );
    },
    updateUser: function(updatedUser) {
      const apiClient = apiClientCreator(`admin/user/${updatedUser.id}`);
      apiClient.put("", updatedUser).then(
        res => {
          if (res.status === 201) {
            alert(`The User ${updatedUser.email} Updated Successfully`);
            if (confirm("Are you want to Update another User ?")) {
              this.resetForm();
              this.detailsStageCompleted = false;
            } else {
              this.showUserMgmt();
            }
            this.fetchUsers();
          }
        },
        () => {
          alert(
            `Cannot Add User: The User ${updatedUser.email} is already registered, please try another Username`
          );
        }
      );
    },

    // deleteUser: function(user) {
    //   const apiClient = apiClientCreator(`admin/user/${user.id}`);
    //   apiClient.delete().then(
    //     res => {
    //       if (res.status === 201) {
    //         alert(`The User ${user.email} Deleted Successfully`);
    //         if (confirm(`Do you want delete another ?`)) {
    //           this.resetForm();
    //         } else {
    //           this.showUserMgmt();
    //         }
    //         this.fetchUsers();
    //       }
    //     },
    //     () => {
    //       alert(
    //         `Cannot Delete User: The User ${user.email} is not exist, please try another Username or refresh the page`
    //       );
    //     }
    //   );
    // },

    showUserMgmt: function() {
      // this.$store.commit('clients/showAddEditUsers', true);
      this.$router.push("/");

      this.resetForm();
      this.type = "Add";
      this.selectAdd = true;
      this.selectDelete = false;
      this.selectEdit = false;
      this.wantChangePassword = false;
      this.back();
    },

    handleFileUpload() {
      this.file = this.$refs.file.files[0];
    },

    selectNameToEdit: function(user) {
      this.id = user.id;
      this.role = user.role;
      this.team = user.team_id;
      this.firstName = user.first_name;
      this.lastName = user.last_name;
      this.active = user.active;
      this.stats_active = user.stats_active;
      this.reports_active = user.reports_active;
      this.voip_user = user.voip_user;
      this.backup_voip_user = user.backup_voip_user;
      this.backup_voip_enable = user.backup_voip_enable;
      this.email = user.email;
      this.username_special = user.username_special;
      this.previewImage = user.profile_img;
    },

    optionChoose: function(type) {
      switch (type) {
        case "ADD":
          this.selectAdd = true;
          this.selectDelete = false;
          this.selectEdit = false;
          this.selectProfileImage = false;
          this.wantChangePassword = false;
          this.type = "Add";
          this.resetForm();
          this.fetchUsers();
          break;
        case "EDIT":
          this.selectAdd = false;
          this.selectDelete = false;
          this.selectEdit = true;
          this.selectProfileImage = false;
          this.wantChangePassword = false;
          this.type = "Edit";
          this.resetForm();
          this.fetchUsers();
          break;
        // case "DELETE":
        //   this.selectAdd = false;
        //   this.selectDelete = true;
        //   this.selectEdit = false;
        //   this.selectProfileImage = false;
        //   this.type = "Delete";
        //   this.resetForm();
        //   this.fetchUsers();
        //   break;
        case "UPDATE_IMAGE":
          this.selectProfileImage = true;
          this.selectAdd = false;
          this.selectDelete = false;
          this.selectEdit = false;
          this.wantChangePassword = false;
          this.type = "Update User Profile Image";
          this.resetForm();
          this.fetchUsers();
          break;
        default:
          break;
      }
    },

    next: function() {
      this.detailsStageCompleted = !this.detailsStageCompleted;
    },
    back: function() {
      this.detailsStageCompleted = false;
      this.errors = [];
    },

    resetForm: function() {
      this.id = "";
      this.selectedName = "";
      this.role = "";
      this.team = "";
      this.firstName = "";
      this.lastName = "";
      this.country = "";
      this.socialNumber = "";
      this.email = "";
      this.username_special = "";
      this.password = null;
      this.rePassword = null;
      this.voip_user = null;
      this.backup_voip_user = null;
      this.active = false;
      this.stats_active = false;
      this.reports_active = false;
      this.backup_voip_enable = false;
    },

    submitAdd: function(actionType) {
      if (
        this.role &&
        this.team &&
        this.firstName &&
        this.lastName &&
        this.email &&
        this.password === this.rePassword
      ) {
        const newData = {
          id: this.id,
          role: this.role,
          first_name: this.firstName,
          last_name: this.lastName,
          team_id: this.team,
          email: this.email,
          username_special: this.password,
          password: this.password,
          active: this.active,
          stats_active: this.stats_active,
          reports_active: this.reports_active,
          voip_user: this.voip_user
        };
        if (this.backup_voip_enable) {
          Object.assign(newData, {
            backup_voip_enable: this.backup_voip_enable,
            backup_voip_user: this.backup_voip_user
          });
        } else {
          if (this.backup_voip_user !== null) {
            Object.assign(newData, {
              backup_voip_user: this.backup_voip_user
            });
          }
        }
        if (actionType === "add") {
          this.addNewUser(newData);
        } else {
          this.updateUser(newData);
        }
      }

      this.errors = [];

      if (!this.role) {
        this.errors.push("Role required.");
      }
      if (!this.firstName) {
        this.errors.push("First Name required.");
      }
      if (!this.lastName) {
        this.errors.push("Last Name required.");
      }
      if (!this.email) {
        this.errors.push("Email required.");
      }
      if (this.password !== this.rePassword) {
        this.errors.push("The Passwords are not match");
      }
      if (this.backup_voip_enable && !this.backup_voip_user) {
        this.errors.push("Fill Backup VoIP Ext number to enable backup");
      }
    },

    submitDelete: function() {
      // this.errors = [];
      // if (this.selectedName.length < 1) {
      //   this.errors.push("Choose User to Delete");
      // } else {
      //   if (
      //     confirm(
      //       `You are going to Delete ${this.selectedName.email}, Are you sure ?`
      //     )
      //   ) {
      //     this.deleteUser(this.selectedName);
      //     this.resetForm();
      //   }
      // }
    }
  }
};
</script>
<style scoped>
input[type="radio"]:not(:checked) ~ .radio-sample {
  display: none;
}

.boxMain {
  max-width: 400px;
  padding: 10px;
  margin-left: auto;
  margin-right: auto;
  top: 22px;
}

.btnBoxLeft {
  float: left;
}

.btnBoxLeft {
  float: right;
}

.caution {
  color: red;
}

.divAdd {
  background-color: #cfd8dc;
}
.finish-btn {
}
.img-selector {
  margin-bottom: 20px;
}
.select-standard {
  width: 100%;
  position: relative;
  display: inline-block;
  padding: 4px 4px 4px 10px;
  border-radius: 5px;
  border-style: solid;
  border-color: #90a4ae;
  height: 30px;
  border-width: thin;
  overflow: hidden;
  max-width: 100%;
  text-overflow: ellipsis;
  font-weight: inherit;
  font-size: 10pt;
  box-sizing: border-box;
}

.styleCard {
  box-shadow: 0px 9px 20px rgba(0, 0, 0, 0.05);
  border-radius: 5px;
  overflow: hidden;
  height: max-content;
  min-width: 300px;
  position: absolute;
  margin: auto;
  top: 70px;
  right: 0;
  left: 0;
  width: 40%;
  padding: 20px;
  font-size: 12px;
}
.styleCard h2 {
  font-size: 17px;
}
.styleCard h4 {
  font-size: 14px;
}
.bttn {
  font-family: Montserrat;
  width: max-content;
  margin-top: 0.5rem;
  color: white;
  border: 0;
  border-radius: inherit;
  padding: 5px;
  font-size: 12px;
  cursor: pointer;
  margin-left: 0.5rem;
}
.bttn-blue {
  background-color: #44a2d2;
}
.bttn-red {
  background-color: #dc3545;
}
.bttn-green {
  background-color: #28a745;
}

.top-check-div {
  display: inline-flex;
}

.multi-check-label {
  display: block;
  padding-left: 0.3rem;
  margin-right: 0.2rem;
  margin-left: 1.5rem;
  text-indent: -15px;
  font-size: 12px;
  cursor: pointer;
}
.strong-label {
  font-weight: bold;
}
</style>
